import { useFormik } from 'formik';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CHANGE_PASS } from '../../../constant-value';
import { validationAccountSchema } from '../../../constant-value/schema';
import api from '../../../services/axiosConfig';

const ChangePassword = () => {
    const navigate = useNavigate();
    const [pass, setPass] = useState({
        currentPassword: null,
        password: null,
        confirmPassword: null
      });

    const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik({
        enableReinitialize: true,
        initialValues: pass,
        validationSchema: validationAccountSchema,    
        onSubmit: () => {

            api.post(`/${CHANGE_PASS}`, values).then((res) => {
                if (res.data.isSuccess) {
                    message(res.data.message,'success');
                    navigate("/");
                } else {
                    message(res.data.message,'warn');
                }
            }).catch(error => { 
                if (error.response.status === 401) {
                    message('نام کاربری و یا رمز عبور اشتباه است','warn');
                }
                else{
                    message("جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است", "warn");
                }
            });
        },
    });

    const changeHandle = (evt) => {
        setPass({
            ...pass,
            [evt.target.id]: evt.target.value,
        })
    }

    const message = (message,type) => {
        if (type==='warn') {
            toast.warning(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
        } else {
            toast.success(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
        }
    }

  return (
    // <form onSubmit={handleSubmit}>
    //     <div>
    //         <label>رمز عبور فعلی:</label>
    //         <input className="form-control"
    //             value={values.currentPassword}
    //             onChange={changeHandle}
    //             id="currentPassword"
    //             type="password"
    //             onBlur={handleBlur}
    //         />
    //         {errors.currentPassword && touched.currentPassword && (
    //         <span>{errors.currentPassword}</span>
    //         )}
    //     </div> 

    //     <div>
    //         <label>رمز عبور جدید:</label>
    //         <input className="form-control"
    //             value={values.password}
    //             onChange={changeHandle}
    //             id="password"
    //             type="password"
    //             onBlur={handleBlur}
    //         />
    //         {errors.password && touched.password && (
    //             <span>{errors.password}</span>
    //         )}
    //     </div>        
    //     <div>
    //         <label>تکرار رمز عبور جدید:</label>
    //         <input className="form-control"
    //             value={values.confirmPassword}
    //             onChange={changeHandle}
    //             id="confirmPassword"
    //             type="password"
    //             onBlur={handleBlur}
    //         />
    //         {errors.confirmPassword && touched.confirmPassword && (
    //             <span>{errors.confirmPassword}</span>
    //         )}
    //     </div>   
    //     <button className="btn btn-primary m-2" type="submit">تایید</button>
    // </form>

    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <form onSubmit={handleSubmit} className="card shadow-sm p-4">
            <h4 className="mb-4 text-center text-primary">تغییر رمز عبور</h4>

            {/* رمز عبور فعلی */}
            <div className="mb-3">
              <label className="form-label fw-semibold">رمز عبور فعلی:</label>
              <input
                className={`form-control ${
                  errors.currentPassword && touched.currentPassword ? "is-invalid" : ""
                }`}
                value={values.currentPassword}
                onChange={changeHandle}
                id="currentPassword"
                type="password"
                onBlur={handleBlur}
              />
              {errors.currentPassword && touched.currentPassword && (
                <div className="invalid-feedback d-block">
                  {errors.currentPassword}
                </div>
              )}
            </div>

            {/* رمز عبور جدید */}
            <div className="mb-3">
              <label className="form-label fw-semibold">رمز عبور جدید:</label>
              <input
                className={`form-control ${
                  errors.password && touched.password ? "is-invalid" : ""
                }`}
                value={values.password}
                onChange={changeHandle}
                id="password"
                type="password"
                onBlur={handleBlur}
              />
              {errors.password && touched.password && (
                <div className="invalid-feedback d-block">
                  {errors.password}
                </div>
              )}
            </div>

            {/* تکرار رمز عبور جدید */}
            <div className="mb-4">
              <label className="form-label fw-semibold">تکرار رمز عبور جدید:</label>
              <input
                className={`form-control ${
                  errors.confirmPassword && touched.confirmPassword ? "is-invalid" : ""
                }`}
                value={values.confirmPassword}
                onChange={changeHandle}
                id="confirmPassword"
                type="password"
                onBlur={handleBlur}
              />
              {errors.confirmPassword && touched.confirmPassword && (
                <div className="invalid-feedback d-block">
                  {errors.confirmPassword}
                </div>
              )}
            </div>

            {/* دکمه تایید */}
            <div className="d-grid">
              <button className="btn btn-primary py-2" type="submit">
                تایید تغییرات
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;